import { useMutation } from '@tanstack/react-query';

import { exportPartyToFasterforward } from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';

export default function useExportPartyToFasterForward() {
  return useMutation({
    mutationFn: ({ partyId }: { partyId: string }) =>
      exportPartyToFasterforward(
        {
          params: {
            path: { party_id: partyId },
            query: {},
          },
        },
        wgApi,
      ),
  });
}
